"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'borderLineStyle',
  props: {
    datas: Object,
    title: String
  },
  data: function data() {
    return {
      predefineColors: [
      // 颜色选择器预设
      '#ff4500', '#ff8c00', '#ffd700', '#90ee90', '#00ced1', '#1e90ff', '#c71585', '#409EFF', '#909399', '#C0C4CC', 'rgba(255, 69, 0, 0.68)', 'rgb(255, 120, 0)', 'hsv(51, 100, 98)', 'hsva(120, 40, 94, 0.5)', 'hsl(181, 100%, 37%)', 'hsla(209, 100%, 56%, 0.73)', '#c7158577'],
      borderType: [
      //线类型
      {
        icon: 'icon-solid',
        text: '实线',
        type: 'solid'
      }, {
        icon: 'icon-xuxian',
        text: '虚线',
        type: 'dashed'
      }, {
        icon: 'icon-dianxian',
        text: '点线',
        type: 'dotted'
      }]
    };
  }
};